var validateInput = function (type, text) {
    var regexName = /^[a-zA-Zа-яА-Я0-9_-]{3,16}$/;
    var regexMail = /^[A-Z0-9._%+-]+@[A-Z0-9-]+.+.[A-Z]{2,4}$/i;
    var regexPassword = /^[a-zA-Z0-9_-]{8,}$/;
    var result = false;
    switch (type) {
        case 'text':
            result = regexName.test(text);
            break;
        case 'email':
            result = regexMail.test(text);
            break;
        case 'password':
            result = regexPassword.test(text);
            break;
        default:
            break;
    }
    return result;
};
export { validateInput };
